import { render, staticRenderFns } from "./BtnClose.vue?vue&type=template&id=e7be4554&"
import script from "./BtnClose.vue?vue&type=script&lang=js&"
export * from "./BtnClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports